"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchImportNamesById = exports.createFetchImportNamesById = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatReferences = require("reference-resolvers/lib/formatReferences");

var _get = _interopRequireDefault(require("transmute/get"));

var BASE_URL = 'inbounddb-io/imports';
var GET_NAMES_URL = BASE_URL + "/get-names";

var createFetchImportNamesById = function createFetchImportNamesById(_ref) {
  var httpClient = _ref.httpClient;
  return function (ids) {
    return httpClient.put(GET_NAMES_URL, {
      data: ids
    }).then(function (response) {
      return ids.map(function (id) {
        return {
          id: id,
          importName: response.hits[id] || null
        };
      });
    }).then((0, _formatReferences.formatToReferencesList)({
      getId: (0, _get.default)('id'),
      getLabel: (0, _get.default)('importName')
    }));
  };
};

exports.createFetchImportNamesById = createFetchImportNamesById;
var fetchImportNamesById = createFetchImportNamesById({
  httpClient: _apiClient.default
});
exports.fetchImportNamesById = fetchImportNamesById;